

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import BackButton from '../partials/BackButton/BackButton';

function QuestionsAndAnswersPage(props) {

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  function onClickBackButton() {
    window.history.back();
  };

  return (
    <div className='questions-and-answers-page'>
      <BackButton text='חזרה לפרטי החיוב' onClickBackButton={onClickBackButton}/>
      {props.isEnergy ?
        <ContentArea
        noWrap
        key='QuestionsAndAnswersContentAreaEnergy'
        context={props.context}
        data={props.iContent.questionsAndAnswersContentAreaEnergy}
        propertyName='QuestionsAndAnswersContentAreaEnergy'
        /> :
        <ContentArea
        noWrap
        key='QuestionsAndAnswersContentArea'
        context={props.context}
        data={props.iContent.questionsAndAnswersContentArea}
        propertyName='QuestionsAndAnswersContentArea'
      />
      }
    </div>

  );
}

const mapStateToProps = (state) => {
  return {
    isEnergy: state.personalAreaInvoicesPage.isEnergy,
  };
};
const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionsAndAnswersPage);
